import React, { PropsWithChildren } from 'react';
import bem from '../../../lib/bemUtils/bem';
import { Hyperlink, HyperlinkTarget } from '../../../components/atoms/Hyperlink';
import { Icons, SVG } from '../../../components/atoms/SVG';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import { ContentLinkModifier } from './ContentLink.modifier';
import { getLinkItemIcon, getUrlProtocol } from '../../../components/atoms/Hyperlink/Hyperlink.utils';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';

type ContentLinkProps = PropsWithChildren<{
  to: string;
  id?: string;
  title?: string;
  rel?: string;
  target?: string;
  newWindowIndicator?: boolean;
  tooltipPlacement?: TooltipPlacement;
  routing?: boolean;
  external?: boolean;
  modifier?: Modifier<ContentLinkModifier.REGULAR>;
}>;

export function ContentLink(props: ContentLinkProps) {
  let spriteId = getLinkItemIcon(getUrlProtocol(props.to));

  if (!spriteId && props.target !== HyperlinkTarget.SELF && props.newWindowIndicator) {
    spriteId = Icons.EXTERNAL_LINK_ARROW;
  }

  return (
    <Hyperlink {...props} className={`${bem('content-link', props.modifier)} font-bold-15-19`}>
      {spriteId ? <SVG svgSpriteId={spriteId} svgClass="content-link__new-window-indicator" /> : null}
      {props.children}
    </Hyperlink>
  );
}
